/**
 * Extracts a video ID from a video URL path.
 * The ID is the filename (without extension) from the last path segment.
 *
 * Examples:
 * - "https://videos.amberstudent.com/res/videos/1cdc3261.mp4?h=720" → "1cdc3261"
 * - ".../inventories/zibzfldt1sys2nwpsrwj/1659814122.mp4?h=720" → "1659814122"
 * - "some/path/video-name.mp4" → "video-name"
 * - "https://www.youtube.com/watch?v=Rm6BUCSBiEU&feature=youtu.b" → "Rm6BUCSBiEU"
 * - "https://youtu.be/Rm6BUCSBiEU" → "Rm6BUCSBiEU"
 */
const extractVideoId = (path: string | undefined | null): string => {
  if (!path) return "";

  try {
    // Handle YouTube URLs — extract the v= parameter or youtu.be path
    if (path.includes("youtube.com") || path.includes("youtu.be")) {
      const vMatch = path.match(/[?&]v=([^&]+)/);
      if (vMatch) return vMatch[1];
      // youtu.be/VIDEO_ID format
      const shortMatch = path.match(/youtu\.be\/([^?&#]+)/);
      if (shortMatch) return shortMatch[1];
    }

    // Remove query params and hash
    const cleanPath = path.split("?")[0].split("#")[0];

    // Get the last segment of the path
    const segments = cleanPath.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1] || "";

    // Remove file extension
    const dotIndex = lastSegment.lastIndexOf(".");
    return dotIndex > 0 ? lastSegment.substring(0, dotIndex) : lastSegment;
  } catch {
    return "";
  }
};

export default extractVideoId;
